import { Component, OnInit } from '@angular/core';
import { HttpClient  } from '@angular/common/http';
import { menulist } from '../class/status';
import { page } from '../class/status';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-tagsystem',
    templateUrl: './tagsystem.component.html',
    styleUrls: ['./tagsystem.component.css']
})

export class TagsystemComponent implements OnInit {

    pageobj:page = {page:0,count:10,total_count:0};
    now:string='0';
    act:string='0';
    menu_list:menulist = [{id:'0',name:'Tag設定'}]
    type_list:any=[{id:'0',name:'系統'},{id:'1',name:'組合'},{id:'2',name:'自選'}]
    edit_data:any={mode:'-2'};
    category_list:any=[];
    tmpcategory_list:any=[];
    field_select:any=[];
    variable1_select:any=[];
    table_select:any=[{id:'1',name:'用戶相關',value:'user'},{id:'2',name:'用戶行為相關',value:'user_behavor'},{id:'3',name:'用戶花費相關',value:'daily_consume'},{id:'4',name:'用戶收入相關',value:'daily_income'},{id:'5',name:'男用戶訊息相關',value:'daily_activity_male'},{id:'6',name:'女用戶訊息相關',value:'daily_activity'}];
    operation1_select:any=[{id:'',name:'請選擇類型',value:''},{id:'1',name:'大於',value:'>'},{id:'2',name:'小於',value:'<'},{id:'3',name:'等於',value:'='},{id:'4',name:'大於等於',value:'>='},{id:'5',name:'小於等於',value:'<='}];
    operation2_select:any=[{id:'',name:'請選擇類型',value:''},{id:'1',name:'大於',value:'>'},{id:'2',name:'小於',value:'<'},{id:'3',name:'等於',value:'='},{id:'4',name:'大於等於',value:'>='},{id:'5',name:'小於等於',value:'<='}];
    type_select:any=[{id:'0',name:'交集',value:'0'},{id:'1',name:'聯集',value:'1'},{id:'2',name:'差集',value:'2'}];

    data:any=[];
    loading:boolean=false;
    pageobjstr:string=JSON.parse(JSON.stringify(this.pageobj))
    tag_list_type:any[] = [];
    search_model:any=[];
    user_tag:any=[];
    user_total:number = 0;      // 後端 get_tag_list act=1 回的名單總數；系統／組合 tag 只回前 300 筆預覽，user_tag.length 可能小於它
    user_list_dt:string = '';   // 這份名單是哪一列 tag_map（cron 幾點算的）

    tips1 = '';
    tips2 = '';

    //運算符號一 的判斷是否顯示的tag欄位類型
    operation1fieldlist:any=[-2,'register_os_type','hot','os_type','country_code','is_hidden','is_enable','is_online','gender','identity'];

    //運算符號二 的判斷是否顯示的tag欄位類型
    operation2fieldlist:any=[-2,'register_os_type','hot','country_code','identity','is_hidden','is_enable','is_online','gender','os_type'];




    //條件一 下拉的判斷是否顯示的tag欄位類型
    variable1fieldlist:any=[-2,'date','last_singin_date','hot','register_date','birthday','trade_num','total_income','voice_room_income','donate_income','other','date_reward','live_reward','gift_reward','active_reward','game_income','album_income','video_income','voice_income','accept_call_num','reject_call_num','trade_people_num','cust_all_diamond','customer_lifespan','text_income','voice_room_consume','total_consume','donate_consume','send_chat','receive_chats','other_consume','date_consume','live_consume','gift_consume','active_consume','game_consume','album_consume','video_consume','voice_consume','text_consume','refund_num','refund_twd','deposit_num','deposit_twd','withdrawal','rece_all_diamond','active_period','receve_chats_num','send_chats_num','send_call_num','receive_call_num','total_voice','total_video','age','diamond','diamond_twd','followers','views'];

    //條件一 input的判斷是否顯示的tag欄位類型
    variable1fieldinputlist:any=['trade_num','last_singin_date','total_income','voice_room_income','donate_income','other','date_reward','live_reward','gift_reward','active_reward','game_income','album_income','video_income','voice_income','accept_call_num','reject_call_num','trade_people_num','cust_all_diamond','customer_lifespan','text_income','voice_room_consume','total_consume','donate_consume','send_chat','receive_chats','other_consume','date_consume','live_consume','gift_consume','active_consume','game_consume','album_consume','video_consume','voice_consume','text_consume','refund_num','refund_twd','deposit_num','deposit_twd','withdrawal','rece_all_diamond','active_period','receve_chats_num','send_chats_num','send_call_num','receive_call_num','total_voice','total_video','age','diamond','diamond_twd','followers','views'];

    //條件一 date的判斷是否顯示的tag欄位類型
    variable1fielddatelist:any=['date','register_date','birthday'];

    //條件二 下拉的判斷是否顯示的tag欄位類型
    variable2fieldlist:any=[-2,'date','last_singin_date','hot','register_date','birthday','trade_num','total_income','voice_room_income','donate_income','other','date_reward','live_reward','gift_reward','active_reward','game_income','album_income','video_income','voice_income','register_os_type','country_code','identity','is_online','is_hidden','is_enable','gender','customer_lifespan','text_income','voice_room_consume','total_consume','donate_consume','send_chat','receive_chats','other_consume','date_consume','live_consume','gift_consume','active_consume','game_consume','album_consume','video_consume','voice_consume','text_consume','refund_num','refund_twd','deposit_num','deposit_twd','withdrawal','os_type','accept_call_num','send_chats_num','active_period','rece_all_diamond','cust_all_diamond','trade_people_num','receve_chats_num','reject_call_num','send_call_num','receive_call_num','total_voice','total_video','age','diamond','diamond_twd','followers','views'];

    //條件二 input的判斷是否顯示的tag欄位類型
    variable2fieldinputlist:any=['trade_num','last_singin_date','total_income','voice_room_income','donate_income','other','date_reward','live_reward','gift_reward','active_reward','game_income','album_income','video_income','voice_income','accept_call_num','reject_call_num','receve_chats_num','customer_lifespan','text_income','voice_room_consume','total_consume','donate_consume','send_chat','receive_chats','other_consume','date_consume','live_consume','gift_consume','active_consume','game_consume','album_consume','video_consume','voice_consume','text_consume','refund_num','refund_twd','deposit_num','deposit_twd','withdrawal','cust_all_diamond','rece_all_diamond','active_period','trade_people_num','send_chats_num','send_call_num','receive_call_num','total_voice','total_video','age','diamond','diamond_twd','followers','views'];

    //條件二 date的判斷是否顯示的tag欄位類型
    variable2fielddatelist:any=['date','register_date','birthday'];

    //判斷幾天內是否顯示
    daylist:any=['active_period','cust_all_diamond','rece_all_diamond'];

    colorNum:number = 1;

    constructor(public httpClient: HttpClient,) { }

    ngOnInit(): void {
        this.init_list();
    }

    isSubTagsOpen: boolean[] = [false, false, false];

    preventNegative(event: KeyboardEvent) {
        if (event.key === '-' || event.key === 'e' || event.key === '.' || event.key === '+' || event.key === ',' ) {
          event.preventDefault();
        }
    }

    variable1_selectls(){

        this.edit_data.variable1 = -2;
        this.edit_data.variable2 = -2;
        this.edit_data.variable3 = '';

        switch (this.edit_data.field) {
            case 'register_os_type':
                this.edit_data.operation1 = '=';
                this.variable1_select = [{id:'1',name:'Android',value:'1'},{id:'2',name:'iOS',value:'2'},{id:'3',name:'Web',value:'3'}];
                this.tips1 = '請選擇註冊的作業系統';
                this.tips2 = '';
                break;
            case 'os_type':
                this.edit_data.operation1 = '=';
                this.variable1_select = [{id:'1',name:'Android',value:'1'},{id:'2',name:'iOS',value:'2'},{id:'3',name:'Web',value:'3'}];
                this.tips1 = '請選擇裝置的作業系統';
                this.tips2 = '';
                break;
            case 'country_code':
                this.edit_data.operation1 = '=';
                this.variable1_select = [
                    {id:'1',name:'美、加',value:'1'},
                    {id:'2',name:'英國',value:'44'},
                    {id:'3',name:'馬來西亞',value:'60'},
                    {id:'4',name:'澳大利亞',value:'61'},
                    {id:'5',name:'印度',value:'62'},
                    {id:'6',name:'菲律賓',value:'63'},
                    {id:'7',name:'新加坡',value:'65'},
                    {id:'8',name:'泰國',value:'66'},
                    {id:'9',name:'日本',value:'81'},
                    {id:'10',name:'奈及利亞',value:'234'},
                    {id:'11',name:'愛爾蘭',value:'353'},
                    {id:'12',name:'芬蘭',value:'358'},
                    {id:'13',name:'香港',value:'852'},
                    {id:'14',name:'台灣',value:'886'},
                ];
                this.tips1 = '請選擇國家';
                this.tips2 = '';
                break;
            case 'gender':
                    this.edit_data.operation1 = '=';
                    this.variable1_select = [
                        {id:'1',name:'男',value:'1'},
                        {id:'2',name:'女',value:'2'},
                        {id:'3',name:'不限(官方帳號)',value:'3'},
                    ];
                    this.tips1 = '請選擇性別';
                    this.tips2 = '';
                    break;
                case 'birthday':
                    this.variable1_select = [
                        {id:'1',name:'1月',value:'1'},
                        {id:'2',name:'2月',value:'2'},
                        {id:'3',name:'3月',value:'3'},
                        {id:'4',name:'4月',value:'4'},
                        {id:'5',name:'5月',value:'5'},
                        {id:'6',name:'6月',value:'6'},
                        {id:'7',name:'7月',value:'7'},
                        {id:'8',name:'8月',value:'8'},
                        {id:'9',name:'9月',value:'9'},
                        {id:'10',name:'10月',value:'10'},
                        {id:'11',name:'11月',value:'11'},
                        {id:'12',name:'12月',value:'12'},
                    ];
                    this.tips1 = '請選擇日期';
                    this.tips2 = '請選擇日期';
                    break;
                case 'age':
                    this.tips1 = '請輸入年齡';
                    this.tips2 = '請輸入年齡';
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'diamond':
                    this.tips1 = '請輸入鑽石數';
                    this.tips2 = '請輸入鑽石數';
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'diamond_twd':
                    // 身上台幣＝現有鑽石換算：女生 /17、男生 /4（與履歷頁「約 NT$」同一組匯率），後端 cron 取整數後比對
                    this.tips1 = '請輸入台幣金額（例：1000）';
                    this.tips2 = '請輸入台幣金額';
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'followers':
                    this.tips1 = '請輸入被關注數';
                    this.tips2 = '請輸入被關注數';
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'hot':
                    this.tips1 = '請輸入要取前幾名';
                    this.tips2 = '';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'views':
                    this.tips1 = '請輸入被觀看次數';
                    this.tips2 = '請輸入被觀看次數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;

                case 'is_hidden':
                    this.tips1 = '請選擇是否要隱藏上線';
                    this.tips2 = '';
                    this.edit_data.operation1 = '=';
                    this.variable1_select = [
                        {id:'1',name:'關',value:'0'},
                        {id:'2',name:'開',value:'1'},
                    ];
                    break;
                case 'is_enable':
                    this.tips1 = '請選擇是否停權';
                    this.tips2 = '';
                    this.edit_data.operation1 = '=';
                    this.variable1_select = [
                        {id:'1',name:'是',value:'0'},
                        {id:'2',name:'否',value:'1'},
                    ];
                    break;
                case 'is_online':
                    this.tips1 = '請選擇是否在線';
                    this.tips2 = '';
                    this.edit_data.operation1 = '=';
                    this.variable1_select = [
                        {id:'1',name:'離線',value:'0'},
                        {id:'2',name:'忙碌',value:'1'},
                        {id:'3',name:'在線',value:'2'},
                    ];
                    break;
                case 'identity':
                    this.tips1 = '請選擇該身分';
                    this.tips2 = '';
                    this.edit_data.operation1 = '=';
                    this.variable1_select = [
                        {id:'1',name:'簽約員工',value:'0'},
                        {id:'2',name:'一般用戶',value:'1'},
                        {id:'3',name:'內部員工',value:'2'},
                        {id:'4',name:'經紀成員',value:'3'},
                        {id:'5',name:'業配人員',value:'4'},
                        {id:'6',name:'陪聊',value:'5'},
                        {id:'7',name:'內部經紀',value:'6'},
                        {id:'8',name:'官方帳號',value:'99'},
                    ];
                    break;
                case 'total_video':
                    this.tips1 = '請輸入視訊秒數';
                    this.tips2 = '請輸入視訊秒數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'total_voice':
                    this.tips1 = '請輸入語音秒數';
                    this.tips2 = '請輸入語音秒數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'receive_call_num':
                    this.tips1 = '請輸入次數';
                    this.tips2 = '請輸入次數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'send_call_num':
                    this.tips1 = '請輸入通數';
                    this.tips2 = '請輸入通數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'accept_call_num':
                    this.tips1 = '請輸入接通數';
                    this.tips2 = '請輸入接通數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'reject_call_num':
                    this.tips1 = '請輸入拒絕接通數';
                    this.tips2 = '請輸入拒絕接通數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'receve_chats_num':
                    this.tips1 = '請輸入收到的訊息數';
                    this.tips2 = '請輸入收到的訊息數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'send_chats_num':
                    this.tips1 = '請輸入回應的訊息數';
                    this.tips2 = '請輸入回應的訊息數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'trade_people_num':
                    this.tips1 = '請輸入交易人次數';
                    this.tips2 = '請輸入交易人次數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'register_date':
                    this.tips1 = '請輸入註冊日';
                    this.tips2 = '請輸入註冊日';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'last_singin_date':
                    this.tips1 = '請輸入幾天';
                    this.tips2 = '請輸入幾天';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'cust_all_diamond':
                    this.tips1 = '請輸入鑽石數';
                    this.tips2 = '請輸入鑽石數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'rece_all_diamond':
                    this.tips1 = '請輸入鑽石數';
                    this.tips2 = '請輸入鑽石數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'deposit_twd':
                    this.tips1 = '請輸入儲值金額';
                    this.tips2 = '請輸入儲值金額';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'deposit_num':
                    this.tips1 = '請輸入儲值筆數';
                    this.tips2 = '請輸入儲值筆數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'refund_twd':
                    this.tips1 = '請輸入退款金額';
                    this.tips2 = '請輸入退款金額';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'refund_num':
                    this.tips1 = '請輸入退款筆數';
                    this.tips2 = '請輸入退款筆數';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'withdrawal':
                    this.tips1 = '請輸入提領金額';
                    this.tips2 = '請輸入提領金額';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'receive_chats':
                    this.tips1 = '請輸入數量';
                    this.tips2 = '請輸入數量';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'send_chat':
                    this.tips1 = '請輸入數量';
                    this.tips2 = '請輸入數量';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
                case 'trade_num':
                    this.tips1 = '請輸入數量';
                    this.tips2 = '請輸入數量';
                    this.edit_data.variable3 = 0;
                    this.edit_data.variable1 = 0;
                    this.edit_data.variable2 = 0;
                    this.variable1_select = [];
                    break;
            default:
                this.tips1 = '請輸入鑽石數';
                this.tips2 = '請輸入鑽石數';
                this.edit_data.variable1 = 0;
                this.edit_data.variable2 = 0;
                this.variable1_select = [];
                break;
        }

        console.log('this.edit_data.field',this.edit_data.field);

    }


    checktable(num){

        if(this.edit_data.tables == 'user'){

            if(num < 0){
                this.edit_data.field = -2;
            }


            this.field_select=[
                {id:'1',name:'註冊作業系統',value:'register_os_type'},
                {id:'2',name:'裝置作業系統',value:'os_type'},
                {id:'3',name:'國家',value:'country_code'},
                {id:'4',name:'性別',value:'gender'},
                {id:'5',name:'生日',value:'birthday'},
                {id:'6',name:'年齡',value:'age'},
                {id:'7',name:'鑽石',value:'diamond'},
                {id:'15',name:'身上台幣（鑽石換算：女÷17、男÷4）',value:'diamond_twd'},
                {id:'8',name:'被關注數',value:'followers'},
                {id:'9',name:'熱門男女神',value:'hot'},
                {id:'10',name:'被觀看次數',value:'views'},
                {id:'11',name:'隱藏上線',value:'is_hidden'},
                {id:'12',name:'是否停權',value:'is_enable'},
                {id:'13',name:'線上狀態',value:'is_online'},
                {id:'14',name:'身分',value:'identity'},
            ];

        }

        if(this.edit_data.tables == 'user_behavor'){

            if(num < 0){
                this.edit_data.field = -2;
            }

            this.field_select=[
                {id:'1',name:'視訊秒數',value:'total_video'},
                {id:'2',name:'語音秒數',value:'total_voice'},
                {id:'3',name:'收到的語音/視訊次數',value:'receive_call_num'},
                {id:'4',name:'主動撥打的通數',value:'send_call_num'},
                {id:'5',name:'接通的電話數(不管主被動)',value:'accept_call_num'},
                {id:'6',name:'拒絕通話次數',value:'reject_call_num'},
                {id:'7',name:'收到的訊息數',value:'receve_chats_num'},
                {id:'8',name:'回應的訊息數',value:'send_chats_num'},
                {id:'9',name:'交易人次',value:'trade_people_num'},
                {id:'10',name:'註冊日',value:'register_date'},
                {id:'11',name:'最後登入日',value:'last_singin_date'},
                {id:'12',name:'活躍時段',value:'active_period'},
                {id:'13',name:'總花費鑽石',value:'cust_all_diamond'},
                {id:'14',name:'總收穫鑽石',value:'rece_all_diamond'},
                {id:'15',name:'儲值金額',value:'deposit_twd'},
                {id:'16',name:'儲值筆數',value:'deposit_num'},
                {id:'17',name:'退款金額',value:'refund_twd'},
                {id:'18',name:'退款筆數',value:'refund_num'},
                {id:'19',name:'提領金額',value:'withdrawal'},
            ];

        }

        if(this.edit_data.tables == 'daily_consume'){

            if(num < 0){
                this.edit_data.field = -2;
            }

            this.field_select=[
                {id:'1',name:'文字花費',value:'text_consume'},
                {id:'2',name:'語音花費',value:'voice_consume'},
                {id:'3',name:'視訊花費',value:'video_consume'},
                {id:'4',name:'相簿花費',value:'album_consume'},
                {id:'5',name:'遊戲花費',value:'game_consume'},
                {id:'6',name:'活動花費',value:'active_consume'},
                {id:'7',name:'禮物花費',value:'gift_consume'},
                {id:'8',name:'直播花費',value:'live_consume'},
                {id:'9',name:'約會花費',value:'date_consume'},
                {id:'10',name:'其他花費',value:'other_consume'},
                {id:'11',name:'收到的訊息數',value:'receive_chats'},
                {id:'12',name:'發送的訊息數',value:'send_chat'},
                {id:'13',name:'紅包花費',value:'donate_consume'},
                {id:'14',name:'語音房花費',value:'voice_room_consume'},
                {id:'15',name:'總花費',value:'total_consume'},
            ];

        }


        if(this.edit_data.tables == 'daily_income'){

            if(num < 0){
                this.edit_data.field = -2;
            }

            this.field_select=[
                {id:'1',name:'文字收益',value:'text_income'},
                {id:'2',name:'語音收益',value:'voice_income'},
                {id:'3',name:'視訊收益',value:'video_income'},
                {id:'4',name:'相簿收益',value:'album_income'},
                {id:'5',name:'遊戲收益',value:'game_income'},
                {id:'6',name:'活動獎勵',value:'active_reward'},
                {id:'7',name:'禮物收益',value:'gift_reward'},
                {id:'8',name:'直播收益',value:'live_reward'},
                {id:'9',name:'約會收益',value:'date_reward'},
                {id:'10',name:'其他收益',value:'other'},
                {id:'11',name:'聊天室紅包收益',value:'donate_income'},
                {id:'12',name:'語音房收益',value:'voice_room_income'},
                {id:'13',name:'總收益',value:'total_income'},
                {id:'14',name:'交易次數',value:'trade_num'},
            ];

        }

        if(this.edit_data.tables == 'daily_activity_male'){

            if(num < 0){
                this.edit_data.field = -2;
            }

            this.field_select=[
                {id:'1',name:'文字',value:'get_text_num'},
                {id:'2',name:'語音通話秒數',value:'voice_time'},
                {id:'3',name:'視訊通話秒數',value:'video_time'},
                {id:'4',name:'遊戲通話秒數',value:'game_time'},
                {id:'5',name:'發出的動態數',value:'story_num'},
                {id:'6',name:'定期推播接收數',value:'regular_push_num'},
            ];

        }

        if(this.edit_data.tables == 'daily_activity'){

            if(num < 0){
                this.edit_data.field = -2;
            }

            this.field_select=[
                {id:'1',name:'發出的訊息數',value:'text_num'},
                {id:'2',name:'接收訊息數',value:'get_text_num'},
                {id:'3',name:'個人頁被觀看自動回文數',value:'auto_text_num'},
                {id:'4',name:'語音通話秒數',value:'voice_time'},
                {id:'5',name:'視訊通話秒數',value:'video_time'},
                {id:'6',name:'遊戲通話秒數',value:'game_time'},
                {id:'7',name:'發出的動態數',value:'story_num'},
            ];

        }

    }

    changecolor(colorNum){
        this.colorNum = colorNum;
    }

    selectType(){

        if(this.edit_data.type == 2){
            this.tmpcategory_list = this.category_list;
            this.category_list = [{id: '5', name: '後台設定'}];
        }else{
            if(this.tmpcategory_list.length > 0){
                this.category_list =  this.tmpcategory_list;
            }
        }

    }


    deault(){
        this.edit_data = {category:'-2',type:'-2',status:1,variable1:0,variable2:0,operation1:'',operation2:'',anotheract:0,tables:'-2',field:-2,sid:-2};
        this.user_tag = [];
        this.user_total = 0;
        this.user_list_dt = '';
    }

    toggleSubTags(index: number) {
        this.isSubTagsOpen[index] = !this.isSubTagsOpen[index];
    }

    save(type:number){

        if(this.edit_data.type == -2 || this.edit_data.sid == -2){
            Swal.fire("Tag類別或Tag類型未選擇!", "", "error");
        }else{
            if(type == 0){
                this.loading = true;
                const body = {edit_data:this.edit_data,type:0,user:this.user_tag};
                this.httpClient.post<any>("/update_tag_list.php",body).subscribe(res => {
                    this.loading = false;
                    if(res.status){
                        Swal.fire("已新增完成!", "", "success");
                        this.init_list();
                    }
                });
            }

            if(type == 1){
                this.loading = true;
                const body = {edit_data:this.edit_data,type:1,user:this.user_tag};
                this.httpClient.post<any>("/update_tag_list.php",body).subscribe(res => {
                    this.loading = false;
                    if(res.status){
                        Swal.fire("已更新完成!", "", "success");
                        this.init_list();
                    }
                });
            }
        }
    }

    tagview(id){
        this.loading = true;
        const body = {act:1,id:id};
        this.httpClient.post<any>("/get_tag_list.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.edit_data = res.data[0];
                this.user_tag = res.userData || [];
                this.user_total = res.user_total !== undefined ? Number(res.user_total) : this.user_tag.length;
                this.user_list_dt = res.user_list_dt || '';
                this.checktable(0);
            }
        });
    }

    deletetaglist(item){
        Swal.fire({
            title: "確定要刪除" + item.name + "的tag?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "刪除",
            cancelButtonText: "取消",
        }).then((result) => {
            if (result.isConfirmed) {

                const body = {edit_data:this.edit_data,type:2,user:this.user_tag};
                this.httpClient.post<any>("/update_tag_list.php",body).subscribe(res => {
                    this.loading = false;
                    if(res.status){
                        Swal.fire("已刪除完成!", "", "success");
                        this.init_list();
                    }
                });

            }
        });

    }

    deletetag(item){

        Swal.fire({
            title: "確定要刪除" + item.name + "的tag?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "刪除",
            cancelButtonText: "取消",
        }).then((result) => {
            if (result.isConfirmed) {

                this.user_tag = this.user_tag.filter(item => item.id !== item.id);

                Swal.fire({
                    title: "已刪除!",
                    icon: "success"
                });
            }
        });

    }

    init_list(){
        this.loading = true;
        const body = {page: this.pageobj.page,count:this.pageobj.count,type:this.now,act:0};
        this.httpClient.post<any>("/get_tag_list.php",body).subscribe(res => {
            this.loading = false;
            if(res.status){
                this.data = res.data;
                this.category_list = res.category_list;
                this.tag_list_type = res.tag_list_type;
                this.pageobj.total_count = res.total_count;
            }else{
                this.pageobj.total_count = 0
                this.data = [];
            }
            this.pageobjstr=JSON.parse(JSON.stringify(this.pageobj));


        });
    }

    choose(value:string){
        this.now = value;
        this.pageobj.page = 0;
        this.init_list();
    }

    callback(pageobj:page){
        if(JSON.stringify(this.pageobj)!=JSON.stringify(pageobj)){
            this.pageobj = pageobj;
            this.init_list();
        }
    }

    searchstr(item){
        this.search_model = item;
        this.init_list();
    }

    callitem(item){
        console.log('item',item);
        Swal.fire({
            title: "要將" + item.name + "加入此tag標籤嗎?",
            showDenyButton: true,
            showCancelButton: false,
            confirmButtonText: "加入",
            denyButtonText: `取消`
        }).then((result) => {

            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                Swal.fire("已加入!", "", "success");
                this.user_tag.push(item);
            }

        });


    }

}
